import FolderInfiniteContentContainer from './FolderInfiniteContent.container';
import FolderInfiniteContent from './FolderInfiniteContent';

export default FolderInfiniteContentContainer(FolderInfiniteContent);
